import React from "react";
import Modal from "react-bootstrap/Modal";
import { formatDayMonth } from "utils/formatDate";
import DatePicker from "react-datepicker";
import ReactDropdown from "react-dropdown";
import { ChoVayCombo } from "constants/choVayConst";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";

class SearchNoPhaiThu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choVay: {},
      dataSearch: {
        dateTo: currentDate(),
        code: "",
        customerName: "",
        address: "",
        debt: "-1",
        userName: "0",
        trangThaiGiaHan: "0",
        kieuvay: "0",
        tienVay: "",
        typeNgayPhaiTra: "0",
        optionDateMB: "",
        pageIndex: 1,
        pageSize: 20,
      },
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data !== prevState.dataSearch) {
      return { dataSearch: nextProps.data };
    } else return null;
  }
  onChangeData = (field) => (event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState(dataSearch);
  };
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
  };
  // onChangeDate = (field) => (evt) => {
  //   let { dataSearch } = this.state;
  //   dataSearch[field] = formatDayMonth(evt);
  //   this.setState({ dataSearch });
  // };

  onChangeDate = (field) => (evt) => {
    let { dataSearch } = this.state;
    // dataSearch[field] = formatDayMonth(evt); cũ
    dataSearch[field] = formatDayMonth(evt);
    this.setState({ dataSearch });
  };
  onHide = () => {
    let props = this.props;
    props.onHide();
  };
  onSearch = () => {
    let props = this.props;
    let { dataSearch } = this.state;
    if (!dataSearch.dateTo) dataSearch.dateTo = currentDate();
    props.onHide(dataSearch);
    this.setState({ dataSearch });
  };
  onKeyDownDate = (field) => (evt, evt1) => {
    let { dataSearch } = this.state;
    if (evt.keyCode === 8) dataSearch[field] = "";
    this.setState({ dataSearch });
  };
  render() {
    let props = this.props;
    let { dataSearch } = this.state;
    //var dateTo = convertDate(dataSearch.dateTo);

    let {
      optionDateMB,
      typeNgayPhaiTra,
      userName,
      kieuvay,
      trangThaiGiaHan,
      debt,
      address,
      dateTo,
    } = dataSearch;
    return (
      <Modal
        {...props}
        size="modal-dialog modal-lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 class="modal-title color7-bold " id="myModalLabel16">
            <span class="btn-icon-right">
            <img  src="/app-assets/images/icon-tim-kiem-nang-cao.png"/>
            </span>
               Bộ lọc nâng cao
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={this.onHide}
          >
            <img  src="/app-assets/images/icon-dong-popup-v2.png"/>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-12">
              <label for="email-addr" className="color7-bold">Tìm kiếm</label>
              <br />
              <input
                type="text"
                className="form-control input-sm "
                placeholder="Tên, sđt khách hàng"
                onChange={this.onChangeData("customerName")}
                value={dataSearch.customerName}
              />
            </div>
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Đến ngày</label>
              <br />
              {typeNgayPhaiTra === "4" && (
                // <DatePicker
                //   format={"dd/MM/yyyy"}
                //   locale="vi-VN"
                //   onChange={this.onChangeDate("dateTo")}
                //   clearIcon={null}
                //   className="form-control input-sm"
                //   onKeyDown={this.onKeyDownDate("dateTo")}
                //   disabled={true}
                // />
                <DateTimePicker
                  onChange={this.onChangeDate("dateTo")}
                  name="dateTo"
                  readOnly={true}
                />
              )}
              {typeNgayPhaiTra != "4" && (
                // <DatePicker
                //   format={"dd/MM/yyyy"}
                //   locale="vi-VN"
                //   value={dateTo}
                //   onChange={this.onChangeDate("dateTo")}
                //   clearIcon={null}
                //   className="form-control input-sm"
                //   onKeyDown={this.onKeyDownDate("dateTo")}
                // />
                <DateTimePicker
                  onChange={this.onChangeDate("dateTo")}
                  onKeyDown={this.onKeyDownDate("dateTo")}
                  value={convertDate(dateTo)}
                  name="dateTo"
                />
              )}
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Tình trạng</label>
              <br />
              <ReactDropdown
                // options={ChoVayCombo.TinhTrangCombo1}
                options={props.listTinhTrangNo}
                placeholder="Select an option"
                controlClassName="form-control input-sm"
                value={debt}
                onChange={this._onSelect("debt")}
              />
            </div>
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Mã tài sản</label>
              <br />
              <input
                type="text"
                className="form-control input-sm "
                onChange={this.onChangeData("code")}
                // onKeyDown={this.handleKeyDown}
                value={dataSearch.code}
              />
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Ngày phải trả</label>
              <br />
              <ReactDropdown
                options={ChoVayCombo.NgayTraCombo}
                placeholder="Select an option"
                controlClassName="form-control input-sm "
                value={typeNgayPhaiTra}
                onChange={this._onSelect("typeNgayPhaiTra")}
              />
            </div>
          </div>

          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Ngày</label>
              <br />

              {typeNgayPhaiTra === "4" && (
                // <DatePicker
                //   format={"dd/MM/yyyy"}
                //   locale="vi-VN"
                //   value={optionDateMB}
                //   onChange={this.onChangeDate("optionDateMB")}
                //   clearIcon={null}
                //   className="form-control input-sm"
                //   onKeyDown={this.onKeyDownDate("optionDateMB")}
                // />
                <DateTimePicker
                  onChange={this.onChangeDate("optionDateMB")}
                  onKeyDown={this.onKeyDownDate("optionDateMB")}
                  value={convertDate(optionDateMB)}
                  name="dateTo"
                />
              )}
              {typeNgayPhaiTra != "4" && (
                // <DatePicker
                //   format={"dd/MM/yyyy"}
                //   locale="vi-VN"
                //   onChange={this.onChangeDate("optionDateMB")}
                //   clearIcon={null}
                //   className="form-control input-sm"
                //   onKeyDown={this.onKeyDownDate("optionDateMB")}
                //   disabled={true}
                // />
                <DateTimePicker
                  onChange={this.onChangeDate("optionDateMB")}
                  name="dateTo"
                  readOnly={true}
                />
              )}
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Tình trạng gia hạn</label>
              <br />
              <ReactDropdown
                options={ChoVayCombo.TinhTrangTraCombo}
                placeholder="-- Chọn --"
                controlClassName="form-control input-sm "
                value={trangThaiGiaHan}
                onChange={this._onSelect("trangThaiGiaHan")}
              />
            </div>
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="profession">Người tạo hợp đồng</label>
              <ReactDropdown
                onChange={this._onSelect("userName")}
                options={props.userCombo}
                placeholder="Tất cả"
                controlClassName="form-control input-sm "
                value={userName}
              />
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Địa chỉ</label>
              <br />
              <input
                type="text"
                className="form-control input-sm "
                onChange={this.onChangeData("address")}
                value={address}
              />
            </div>
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="profession">Kiểu vay</label>
              <br />
              <ReactDropdown
                options={ChoVayCombo.KieuVayCombo1}
                placeholder="Select an option"
                controlClassName="form-control input-sm "
                value={kieuvay}
                onChange={this._onSelect("kieuvay")}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="text-right">
        <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={this.onHide}
          >
            <span>
              <i class="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
          <button
            type="button"
            class="btn btn-new-main btn-checknew"
            onClick={this.onSearch}
          >
            <span>
              <i class="mdi mdi-magnify"></i>
            </span>{" "}
            Tìm kiếm
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default SearchNoPhaiThu;
